import React, { useContext } from "react";
import PlaceTableData from "./PlaceTableData";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { context } from "../../context/context";
const Places = () => {
    const {
        setPlaceId,
        setTextEditorHTML,
        setLinkTags,
        setAddPhonePlace,
        setAddNamePlace,
        setPlaceFormTag,
        setEditedCategory,
        setEditedCity,
        setEditedCountry,
        setEditedProvince,
        setSelectedCityId,
        setSelectedCategoryId,
        setIsCategorySelected,
        setIsProvinceSelected,
        setIsCountrySelected,
        setCoverPic,
        setCoverPicId,
        setFileList,
        setFileListIds,
    } = useContext(context);
    const handleEmptyState = () => {
        setPlaceId();
        setTextEditorHTML("");
        setLinkTags([]);
        setAddPhonePlace("");
        setAddNamePlace("");
        setPlaceFormTag([]);
        setEditedCategory();
        setEditedCountry();
        setEditedCity();
        setSelectedCategoryId();
        setSelectedCityId();
        setIsCategorySelected(false);
        setIsProvinceSelected(false);
        setIsCountrySelected(false);
        setEditedProvince(null);
        setCoverPic([]);
        setCoverPicId();
        setFileList([]);
        setFileListIds([]);
    };
    return (
        <>
            <Space
                direction="vertical"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                <NavLink to="/addPlace">
                    <Button onClick={handleEmptyState} type="primary">
                        اضافه کردن مکان جدید
                    </Button>
                </NavLink>
            </Space>
            <PlaceTableData />
        </>
    );
};

export default Places;
